import http from '@/http/aisea/axios'
const resource = "/enterprises/crews";

export default {

  search(enterpriseCrewId, payload) {
    return http.get(`${resource}/${enterpriseCrewId}/labors`, {
      params: payload
    });
  },

  fetch(enterpriseCrewId, id) {
    return http.get(`${resource}/${enterpriseCrewId}/labors/${id}`);
  },

  add(enterpriseCrewId, payload) {
    return http.post(`${resource}/${enterpriseCrewId}/labors`, payload);
  },

  update(enterpriseCrewId, id, payload) {
    return http.put(`${resource}/${enterpriseCrewId}/labors/${id}`, payload);
  },

  delete(enterpriseCrewId, id) {
    return http.delete(`${resource}/${enterpriseCrewId}/labors/${id}`);
  },
};
